export const defaultIdleTimeout = 600; // seconds
export const defaultIdleCountdownTimeout = 30; // seconds
